module.exports = __webpack_public_path__ + "static/eagle-389d660297ea8bd0334414e1a7ca2903.png";